import React, { useState } from 'react';
import MaskedInput from 'antd-mask-input';

import FooterInfos from '@src/components/Shared/FooterInfos';
import FooterSociallis from '@src/components/Shared/FotterSociallis';
import AgradecimentoRecorrente from '@src/pages/AgradecimentoRecorrente';
import AgradecimentoUnica from '@src/pages/AgradecimentoUnica';

import { PayPalButton } from 'react-paypal-button';
import { useTheme, useMediaQuery } from '@material-ui/core';


import Button from '@components/Shared/Buttons/Button';
import { Grid } from '@material-ui/core';
import { Form, Input, Spin, Radio, Select as SelectAntd, Checkbox } from 'antd';
import { useHistory } from 'react-router';


import ButtonComponent from '@components/Shared/Buttons/Button';
import InvisibleContent from '@components/Shared/InvisibleContent';
import '@styles/AntStyles.css';
import { addDays } from 'date-fns';

import Cartao from '@assets/Login/cartao.png';
import Energia from '@assets/Login/lampada-de-iluminacao.png';
import Boleto from '@assets/Login/codigo-de-barras.png'
import Pix from '@assets/Login/codigo-qr.png';
import Debito from '@assets/Login/transferencia-de-dinheiro.png';

import Proximo from '@assets/Login/proximo.png';
import ProximoAzul from '@assets/Login/proximo-azul.png';

import Service, {
  IRequestCreatePessoa,
  IRequestCreatePessoaCredito,
  IRequestCreatePessoaDebito,
  IRequestCreatePessoaEnergia,
  IRequestPessoa,
} from './services';

import { MaskCPFeCNPJ } from '@utils/Masks';
import { validaCPFandCNPJ } from '@utils/Validators';
import SearchCEPCorreios from '@utils/SearchCEPCorreios';
import { isReal } from '@utils/Masks';

import useDebounce from '@hooks/useDebounce';


interface IConvenio {
  id: number;
  descricao: string;
}

interface IOperacaoCaixa {
  id: number;
  descricao: string;
  codigo_operacao: string;
}

interface IOperacaoSantander {
  id: number;
  descricao: string;
  codigo_operacao: string;
}

interface IRecorrencia {
  id: number;
  descricao: string;
}

interface IData {
  id: string;
}





const Principal: React.FC = () => {

  const [formPessoaRef] = Form.useForm();
  const [formRef] = Form.useForm();
  const history = useHistory();

  const [loadingCreatePessoaCredito, setLoadingCreatePessoaCredito] = useState(false);
  const [loadingCreatePessoaPix, setLoadingCreatePessoaPix] = useState(false);
  const [loadingCreatePessoaBoleto, setLoadingCreatePessoaBoleto] = useState(false);
  const [loadingCreatePessoaDebito, setLoadingCreatePessoaDebito] = useState(false);
  const [loadingCreatePessoaEnergia, setLoadingCreatePessoaEnergia] = useState(false);
  const [loadingPessoa, setLoadingPessoa] = useState(false);


  const [loading, setLoading] = useState(false);
  const [valorDoacao, setValorDoacao] = useState(false);

  const [formaContribPix, setFormaContribPix] = useState(false);
  const [formaContribCredito, setFormaContribCredito] = useState(false);
  const [formaContribBoleto, setFormaContribBoleto] = useState(false);
  const [formaContribDebito, setFormaContribDebito] = useState(false);
  const [formaContribEnergia, setFormaContribEnergia] = useState(false);

  const [fraseDoacao0, setFraseDoacao0] = useState(false);
  const [fraseDoacao1, setFraseDoacao1] = useState(false);
  const [fraseDoacao2, setFraseDoacao2] = useState(false);
  const [fraseDoacao3, setFraseDoacao3] = useState(false);
  const [fraseDoacao4, setFraseDoacao4] = useState(false);
  const [fraseDoacao5, setFraseDoacao5] = useState(false);
  const [fraseDoacao6, setFraseDoacao6] = useState(false);
  const [fraseDoacao7, setFraseDoacao7] = useState(false);
  const [fraseDoacao8, setFraseDoacao8] = useState(false);
  const [fraseDoacao9, setFraseDoacao9] = useState(false);
  const [fraseDoacao10, setFraseDoacao10] = useState(false);
  const [fraseDoacao11, setFraseDoacao11] = useState(false);
  const [fraseDoacao12, setFraseDoacao12] = useState(false);
  const [fraseDoacao13, setFraseDoacao13] = useState(false);
  const [fraseDoacao14, setFraseDoacao14] = useState(false);
  const [fraseDoacao15, setFraseDoacao15] = useState(false);
  const [fraseDoacao16, setFraseDoacao16] = useState(false);
  const [fraseDoacao17, setFraseDoacao17] = useState(false);
  const [fraseDoacao18, setFraseDoacao18] = useState(false);
  const [fraseDoacao19, setFraseDoacao19] = useState(false);
  const [fraseDoacao20, setFraseDoacao20] = useState(false);
  const [fraseDoacao21, setFraseDoacao21] = useState(false);
  const [fraseDoacao22, setFraseDoacao22] = useState(false);
  const [fraseDoacao23, setFraseDoacao23] = useState(false);
  const [fraseDoacao24, setFraseDoacao24] = useState(false);
  const [fraseDoacao25, setFraseDoacao25] = useState(false);
  const [fraseDoacao26, setFraseDoacao26] = useState(false);
  const [fraseDoacao27, setFraseDoacao27] = useState(false);
  const [fraseDoacao28, setFraseDoacao28] = useState(false);
  const [fraseDoacao29, setFraseDoacao29] = useState(false);

  const [confDadosPessoais, setConfDadosPessoais] = useState(false);
  const [confValorDoacao, setConfValorDoacao] = useState(false);
  const [confFormaContrib, setConfFormaContrib] = useState(false);
  const [doacaoRecorrente, setDoacaoRecorrente] = useState(false);
  const [doacaoPaypal, setDoacaoPaypal] = useState(false);

  const [tipoDocumento, setTipoDocumento] = useState<'pf' | 'pj'>('pf');

  const [valorModifyValorDebito, setValorModifyValorDebito] =
  useState<string>('');

  const [valorPaypal1, setValorPaypal1] =useState<number>(0);
  const [valorPaypal2, setValorPaypal2] =useState<number>(0);
  const [valorPaypal3, setValorPaypal3] =useState<number>(0);
  const [valorPaypal4, setValorPaypal4] =useState<number>(0);
  const [valorPaypal5, setValorPaypal5] =useState<number>(0);


  const [openModalTermo, setOpenModalTermo] =
  useState(false);


  const [loadingCEP, setLoadingCEP] = useState(false);
  const [uf, setUF] = useState<any>();
  const [checkedTermo1, setCheckedTermo1] = useState(false);
  const [checkedTermo2, setCheckedTermo2] = useState(false);

  const [convenioSelecionada, setConvenioSelecionada] =
  useState('');

  const [convenio, setConvenio] = useState<IConvenio[]>([
    { id: 5, descricao: 'BANCO DO BRASIL' },
    { id: 7, descricao: 'BANCO SANTANDER S.A.' },
    { id: 9, descricao: 'BANCO BRADESCO S.A.' },
    { id: 22, descricao: 'CAIXA ECONOMICA FEDERAL' },
  ]);


  const [operacaoCaixa, setOperacaoCaixa] = useState<IOperacaoCaixa[]>([
    { id: 1, descricao: 'Cta. Corrente - P.Física', codigo_operacao: '001' },
    { id: 2, descricao: 'Cta. Simples - P.Física', codigo_operacao: '002' },
    { id: 3, descricao: 'Cta. Corrente - P.Jurídica', codigo_operacao: '003' },
    { id: 4, descricao: 'Entidades Públicas', codigo_operacao: '006' },
    { id: 5, descricao: 'Dep. Inst. Financeiras', codigo_operacao: '007' },
    { id: 6, descricao: 'Consignação em pagamento', codigo_operacao: '011' },
    { id: 7, descricao: 'Poupança - P.Física', codigo_operacao: '013' },
    { id: 8, descricao: 'Conta Benefício', codigo_operacao: '018' },
    { id: 9, descricao: 'Poupança - P.Jurídica', codigo_operacao: '022' },
    { id: 10, descricao: 'Conta Eletrônica', codigo_operacao: '023' },
    { id: 11, descricao: 'Poupança-Créd Imobiliário', codigo_operacao: '028' },
    { id: 12, descricao: 'Dep. Lotéricos', codigo_operacao: '043' },
  ]);

  const [operacaoSantander, setOperacaoSantamder] = useState<IOperacaoSantander[]>([
    { id: 13, descricao: 'Operação 001', codigo_operacao: '001' },
    { id: 14, descricao: 'Operação 002', codigo_operacao: '002' },
    { id: 15, descricao: 'Operação 003', codigo_operacao: '003' },
    { id: 16, descricao: 'Operação 005', codigo_operacao: '005' },
    { id: 17, descricao: 'Conta salário', codigo_operacao: '060' },
    { id: 18, descricao: 'Poupança', codigo_operacao: '071' },
    { id: 19, descricao: 'Cta. Corrente - P.Física', codigo_operacao: '092' },
  ]);

  const [recorrencias, setRecorrencias] = useState<IRecorrencia[]>([
    { id: 1, descricao: 'Mensal' },
    { id: 2, descricao: 'Bimestral' },
    { id: 3, descricao: 'Trimestral' },
    { id: 6, descricao: 'Semestral' },
    { id: 12, descricao: 'Anual' },
  ]);

  const [data, setDatas] = useState<IData[]>([
    { id: '1' },  { id: '2' }, { id: '3' },{ id: '4' },{id: '5' },
    {id: '6' }, {id: '7' }, {id: '8' }, {id: '9' }, {id: '10' },
    {id: '11' }, {id: '12' }, {id: '13' }, {id: '14' }, {id: '15' },
    {id: '16' }, {id: '17' }, {id: '18' }, {id: '19' }, {id: '20' },
    {id: '21' }, {id: '22' }, {id: '23' }, {id: '24' }, {id: '25' },
    {id: '26' }, {id: '27' }, {id: '28' }, {id: '29' }, {id: '29' },
    {id: '30' }, {id: '31' },
  ]);

  const [etapa, setEtapa] = useState(0);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const filterCheckTipoConvenio = (descricao: any) => {
    const forma = convenio.filter(x => x.descricao === descricao);

    if (forma.length > 0) setConvenioSelecionada(forma[0].descricao);
  };


  const HandleChangeEtapa = (value: number) => {
    setEtapa(value);

  };

  function handleInput(e: any) {
    var ss = e.target.selectionStart;
    var se = e.target.selectionEnd;
    e.target.value = e.target.value.toUpperCase();
    e.target.selectionStart = ss;
    e.target.selectionEnd = se;
  };





  async function onSubmitPessoa(values: any) {
    setLoadingPessoa(true);
    setLoading(true);
    //console.log(values);

    const services = new Service();
    const createPessoa: IRequestPessoa = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
        indicador: values.indicador,
        leu_comunicado_privacidade: checkedTermo2,
        concede_compartilhamento_dados: checkedTermo1,
      },
      doacao: {
        valor: parseInt(valorModifyValorDebito),

        cartao: values.cartao === undefined
        ?false
        :true,
        boleto: values.boleto === false,
        pix: values.pix  === false,
        recorrente: values.recorrente  === undefined
          ?false
          :true,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: values.cep,
        uf: values.uf,
      },
      entidade: {
        nome: 'osid'
      },
      campanha:{
        descricao: 'teste',
      },
      cartao: {
        number: values.number,
        verification_value: values.verification_value,
        first_name: values.first_name,
        last_name: values.last_name,
        month: values.month,
        year: values.year,
      },
      debito_automatico: {
        convenio: values.convenio,
        vencimento: values.vencimento,
        numero_agencia: values.numero_agencia,
        digito_agencia: values.digito_agencia,
        numero_conta: values.numero_conta,
        digito_conta: values.digito_conta,
        operacao: values.operacao,
        valor: parseInt(valorModifyValorDebito),
      },
      debito_coelba: {
        numero_conta_energia: values.numero_conta_energia,
        recorrencia: values.recorrencia,
        valor: parseInt(valorModifyValorDebito),
      }
    };
    setLoadingPessoa(false);
  }

  {/* FUNCTION CREATE DOAÇÃO */}

  async function onSubmitCredito(values: any) {

    setLoadingCreatePessoaCredito(true);
    setLoading(true);
    //console.log(values);

    const services = new Service();

    function limparValor(valor: string): string {
      return valor.replace(/[^\d]+/g, '');
    }
    const cepLimpo = limparValor(values.cep);

    const createPessoaCredito: IRequestCreatePessoaCredito = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
        indicador: values.indicador,
        leu_comunicado_privacidade: checkedTermo2,
        concede_compartilhamento_dados: checkedTermo1,
      },
      doacao: {
        valor: parseInt(valorModifyValorDebito),

        cartao: formaContribCredito,
        boleto: values.boleto === false,
        pix: values.pix  === false,
        recorrente: doacaoRecorrente,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: cepLimpo,
        uf: values.uf,
      },
      entidade: {
        nome: 'osid'
      },
      campanha:{
        descricao: 'teste',
      },
      cartao: {
        number: values.number,
        verification_value: values.verification_value,
        first_name: values.first_name,
        last_name: values.last_name,
        month: values.month,
        year: values.year,
      }
    };

    //console.log('entrou aqui')

    const { error, response } = await services.CreatePessoaCredito(createPessoaCredito);

    if (!error) {
      await(setOpenModalTermo(true));

    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");
      //await(setOpenModalTermo(true));
    }

    setLoadingCreatePessoaCredito(false);

    //window.location.reload();
  }

  async function onSubmitPix(values: any) {

    setLoadingCreatePessoaPix(true);
    setLoading(true);
    //console.log(values);

    const services = new Service();

    function limparValor(valor: string): string {
      return valor.replace(/[^\d]+/g, '');
    }
    const cepLimpo = limparValor(values.cep);

    const createPessoaPix: IRequestCreatePessoa = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
        indicador: values.indicador,
        leu_comunicado_privacidade: checkedTermo2,
        concede_compartilhamento_dados: checkedTermo1,
      },
      doacao: {
        valor: parseInt(valorModifyValorDebito),

        cartao: values.cartao === false,
        boleto: values.boleto === false,
        pix: formaContribPix,
        recorrente: doacaoRecorrente,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: cepLimpo,
        uf: values.uf,
      },
      entidade: {
        nome: 'osid'
      },
      campanha:{
        descricao: 'teste',
      }
    };

    //console.log('entrou aqui')

    const { error, response } = await services.CreatePessoa(createPessoaPix);

    if (!error) {
      window.open(response, '_blank');
      await(setOpenModalTermo(true));


    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");
      //await(setOpenModalTermo(true));
    }

    setLoadingCreatePessoaPix(false);

    //window.location.reload();
  }


  async function onSubmitBoleto(values: any){

    setLoadingCreatePessoaBoleto(true);
    setLoading(true);
    //console.log(values);

    const services = new Service();

    function limparValor(valor: string): string {
      return valor.replace(/[^\d]+/g, '');
    }
    const cepLimpo = limparValor(values.cep);

    const createPessoaBoleto: IRequestCreatePessoa = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
        indicador: values.indicador,
        leu_comunicado_privacidade: checkedTermo2,
        concede_compartilhamento_dados: checkedTermo1,
      },
      doacao: {
        valor: parseInt(valorModifyValorDebito),

        cartao: values.cartao === false,
        boleto: formaContribBoleto,
        pix: values.pix === false,
        recorrente: doacaoRecorrente,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: cepLimpo,
        uf: values.uf,
      },
      entidade: {
        nome: 'osid'
      },
      campanha:{
        descricao: 'teste',
      }
    };

    //console.log('entrou aqui')

    const { error, response } = await services.CreatePessoa(createPessoaBoleto);

    if (!error) {
      window.open(response);
      await(setOpenModalTermo(true));


    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");
     // await(setOpenModalTermo(true));
    }

    setLoadingCreatePessoaBoleto(false);

    //window.location.reload();
  }

  async function onSubmitDebito(values: any) {

    setLoadingCreatePessoaDebito(true);
    setLoading(true);
    //console.log(values);

    const services = new Service();

    function limparValor(valor: string): string {
      return valor.replace(/[^\d]+/g, '');
    }
    const cepLimpo = limparValor(values.cep);

    const CreatePessoaDebito: IRequestCreatePessoaDebito = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
        indicador: '',
        leu_comunicado_privacidade: checkedTermo2,
        concede_compartilhamento_dados: checkedTermo1,
      },
      //doacao: {
        //valor: (valorModifyValorDebito) / 100 * 100,
      //},
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: cepLimpo,
        uf: values.uf,
      },
      entidade: {
        nome: 'osid'
      },
      campanha:{
        descricao: 'teste',
      },
      debito_automatico: {
        convenio: values.convenio,
        vencimento: values.vencimento,
        numero_agencia: values.numero_agencia,
        digito_agencia: values.digito_agencia,
        numero_conta: values.numero_conta,
        digito_conta: values.digito_conta,
        operacao: values.operacao,
        valor: parseInt(valorModifyValorDebito),
      }
    };

    //console.log('entrou aqui')

    const { error, response } = await services.CreatePessoaDebito(CreatePessoaDebito);

    if (!error) {
      await(setOpenModalTermo(true));

    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");
      //await(setOpenModalTermo(true));
    }

    setLoadingCreatePessoaDebito(false);

    //window.location.reload();
  }

  async function onSubmitEnergia(values: any) {

    setLoadingCreatePessoaEnergia(true);
    setLoading(true);
    //console.log(values);

    const services = new Service();

    function limparValor(valor: string): string {
      return valor.replace(/[^\d]+/g, '');
    }
    const cepLimpo = limparValor(values.cep);

    const createPessoaEnergia: IRequestCreatePessoaEnergia = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
        indicador: values.indicador,
        leu_comunicado_privacidade: checkedTermo2,
        concede_compartilhamento_dados: checkedTermo1,
      },
      //doacao: {
       // valor: (valorModifyValorDebito) / 100 * 100,
      //},
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: cepLimpo,
        uf: values.uf,
      },
      entidade: {
        nome: 'osid'
      },
      campanha:{
        descricao: 'teste',
      },
      debito_coelba: {
        numero_conta_energia: values.numero_conta_energia,
        recorrencia: values.recorrencia,
        valor: parseInt(valorModifyValorDebito),

      }
    };

    //console.log('entrou aqui')

    const { error, response } = await services.CreatePessoaEnergia(createPessoaEnergia);

    if (!error) {
      await(setOpenModalTermo(true));

    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");
      //await(setOpenModalTermo(true));
    }

    setLoadingCreatePessoaEnergia(false);

    //window.location.reload();
  }

  const searchCEPDebounce = async (value: string) => {
    const searchCEPCorreios = new SearchCEPCorreios();

    setLoadingCEP(true);
    const { error, response } = await searchCEPCorreios.SearchCEP(value);
    setLoadingCEP(false);
    if (!error && response) {
      setUF(response.uf);
      formPessoaRef.setFieldsValue({
        descricao: response.logradouro,
        bairro: response.bairro,
        uf: response.uf,
        cidade: response.localidade,
      });
    }
  };

  const debounceCEP = useDebounce(searchCEPDebounce, 800);

  const onChangeDocumento = (e: any) => {
    const value = e.target.value;

    const { typeDocument, valueModify } = MaskCPFeCNPJ(value);

    setTipoDocumento(typeDocument);


    formPessoaRef.setFieldsValue({
      cpfcnpj: valueModify,
    });

    if (typeDocument === 'pj') {
      formPessoaRef.setFieldsValue({
        sexo: 1,
      });
    }
  };


  const validaDocumento = (_: any, val: any) => {
    const documentoExiste = validaCPFandCNPJ(val);

    if (documentoExiste) {
      return Promise.resolve();
    }

    return Promise.reject(new Error('Digite um documento válido'));
  };

  //function limparForm() {
   // document.querySelector(formPessoaRef)?.onreset();
    //var ss = e.target.selectionStart;
    //var se = e.target.selectionEnd;
    //e.target.value = e.target.value.toUpperCase();
    //e.target.selectionStart = ss;
    //e.target.selectionEnd = se;
  //};


  const onApprove = async () => {
    window.location.reload();
      await(setOpenModalTermo(true));
}

  return (
    <>
      <Grid container>

        {/* ------------------- BACKGROUND ----------------------- */}
        <Grid
      container
      item
      lg={12}
      sm={12}
      xs={12}
      style={{
        backgroundColor: '#0085be',
        backgroundImage: isMobile
          ? 'none'
          : `url('https://amex-osid.s3.sa-east-1.amazonaws.com/osid-aqsm-img_2.png')`,
        backgroundSize: '30%',
        backgroundPosition: 'left bottom',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}
    >

<div
    style={{
      position: 'absolute',
      inset: '0',
      pointerEvents: 'none',
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.7' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
      opacity: 0.08,
      animation: 'grainMove 8s steps(10) infinite',
      zIndex: 0,
    }}
  />

          <InvisibleContent visible={openModalTermo === false}>
          <Form
            form={formPessoaRef}
            size="middle"
            layout="vertical"
            scrollToFirstError={true}
            //onError={() => HandleChangeEtapa(0)}
            labelAlign="left"
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
            requiredMark={false}
            initialValues={{
              nome: '',
              cpfcnpj: '',
              email: '',
              descricao: '',
              numero: '',
              complemento: '',
              bairro: '',
              cidade: '',
              cep: '',
              uf: '',
              indicador: '',
            }}
          >




            {/* --------------- ETAPA 3 (VALOR - DOAÇÃO RECORRENTE / DOAÇÃO ÚNICA) ---------------------------------------------------------------*/}

            <Grid container style={{ display: etapa === 0 ? 'flex' : 'none' }}>


                <Grid container item lg={12} sm={12} xs={12} style={{marginTop: 70}}>

                  <Grid container item lg={12} sm={12} xs={12} justify="center">
                  <img src={'https://amex-osid.s3.sa-east-1.amazonaws.com/osid-aqsm-logo_1_parafundoazul.png'} style={{ height: 140, width: 120}} />
                  </Grid>




                  <Grid container item lg={12} sm={12} xs={12} style={{marginBottom: 5}}>
                    <Grid  container item lg={3} sm={3} xs={12} justify="center" style={{marginLeft: 50}}></Grid>
                    <Grid  container item lg={5} sm={5} xs={12} justify="center"  style={{marginLeft: 5, marginRight: 5}}>
                      <strong style={{fontSize: '17px', color:'#ffc439'}}>
                        Doação Paypal
                      </strong>
                    </Grid>
                    <Grid  container item lg={3} sm={3} xs={12} justify="center"></Grid>
                  </Grid>


                  <Grid container item lg={12} sm={12} xs={12}  style={{marginTop: 15}} >
                    <Grid  container item lg={3} sm={3} xs={12} justify="center" style={{marginLeft: 50}}></Grid>
                    <Grid  container item lg={5} sm={5} xs={12} justify="center"  style={{marginLeft: 5, marginRight: 5}}>
                      <p style={{color: '#FFF'}}>
                      Selecione o valor da doação:
                      </p>
                    </Grid>
                    <Grid  container item lg={3} sm={3} xs={12} justify="center"></Grid>
                  </Grid>

                  {/* --- VALOR -----*/}

                  <Grid item container justify="center" sm={12} xs={12} style={{paddingTop: 20}}>

                    <Form.Item
                      name="valorDoacao"
                      rules={[
                        { required: false, message: 'Campo obrigatório' },
                      ]}
                    >

                      <Grid item lg={12} sm={12} xs={12} container justify="center" >

                        <Grid item lg={1} sm={1} xs={12} container justify="center"></Grid>

                        <Grid item lg={9} sm={9} xs={12} container justify="center">
                          <Form.Item name="valor"
                          rules={[
                            { required: true, message: 'Campo obrigatório' },
                          ]} >

                            <Radio.Group>
                              <Grid container justify="center" style={{paddingLeft: 10}} >
                                <Grid justify="center" lg={2} sm={3} xs={4} style={{paddingRight: 95, paddingTop: 5}}>
                                <Radio  value={10} onClick={(e: any) => setValorDoacao(e)} onChange={(e: any) => {setValorModifyValorDebito(e.target.value); setValorPaypal1(e.target.value);  setFraseDoacao5(true); setFraseDoacao6(false); setFraseDoacao7(false); setFraseDoacao8(false); setFraseDoacao9(false)}} >
                                  <p><strong style={{color:'#a1a1a1', fontSize: 20}}> R$ 10 </strong> </p></Radio>
                                </Grid>

                                <Grid justify="center" lg={2} sm={3} xs={4} style={{paddingRight: 60, paddingTop: 5}}>
                                <Radio value={30} onClick={(e: any) => setValorDoacao(e)} onChange={(e: any) => {setValorModifyValorDebito(e.target.value); setValorPaypal2(e.target.value); setFraseDoacao6(true); setFraseDoacao5(false); setFraseDoacao7(false); setFraseDoacao8(false); setFraseDoacao9(false)}} >
                                  <p><strong style={{color:'#a1a1a1', fontSize: 20}}> R$ 30 </strong> </p></Radio>
                                </Grid>

                                <Grid justify="center" lg={2} sm={3} xs={4} style={{paddingRight: 60, paddingTop: 5}}>
                                <Radio value={60} onClick={(e: any) => setValorDoacao(e)} onChange={(e: any) => {setValorModifyValorDebito(e.target.value); setValorPaypal3(e.target.value); setFraseDoacao7(true); setFraseDoacao5(false); setFraseDoacao6(false); setFraseDoacao8(false); setFraseDoacao9(false)}} >
                                  <p><strong style={{color:'#a1a1a1', fontSize: 20}}> R$ 60 </strong> </p></Radio>
                                </Grid>

                                <Grid justify="center" lg={2} sm={3} xs={4} style={{paddingRight: 60, paddingTop: 5}}>
                                <Radio value={90}  onClick={(e: any) => setValorDoacao(e)} onChange={(e: any) => {setValorModifyValorDebito(e.target.value); setValorPaypal4(e.target.value); setFraseDoacao8(true); setFraseDoacao5(false); setFraseDoacao6(false); setFraseDoacao7(false); setFraseDoacao9(false)}} >
                                  <p><strong style={{color:'#a1a1a1', fontSize: 20}}> R$ 90 </strong> </p></Radio>
                                </Grid>

                                <InvisibleContent
                                  visible={valorDoacao != true}
                                >
                                  <Grid justify="center" lg={2} sm={3} xs={4} style={{paddingRight: 60, paddingTop: 5}}>
                                    <Radio value={''}  onChange={() => setValorDoacao(true)} >
                                      <p><strong style={{color:'#a1a1a1', fontSize: 20}}> R$ _ </strong> </p>
                                    </Radio>
                                  </Grid >
                                </InvisibleContent>

                                <InvisibleContent
                                  visible={valorDoacao === true}
                                >
                                <Grid justify="center" lg={2} sm={3} xs={4} style={{paddingRight: 60, paddingTop: 3}}>
                                      <Form.Item name="valor"
                                        rules={[
                                        {  pattern: /^[0-9]+$/, message: 'Somente números!'},
                                        ]}>
                                        <Input
                                          style={{ height: 89, width: 88}}
                                          type={"text"}
                                          placeholder='R$ 0,00'
                                          onChange={(e: any) => {
                                            formRef.setFieldsValue({
                                              valor: isReal(e.target.value),
                                            });
                                            setValorModifyValorDebito(e.target.value);
                                            setValorPaypal5(e.target.value);
                                            setFraseDoacao9(true);
                                            setFraseDoacao5(false); setFraseDoacao6(false); setFraseDoacao7(false); setFraseDoacao8(false)
                                          }}
                                        />

                                      </Form.Item>
                                  </Grid>

                                </InvisibleContent>
                              </Grid>
                            </Radio.Group>
                          </Form.Item>
                        </Grid>
                        <Grid justify="center" lg={1} sm={1} xs={1} style={{paddingRight: 1, paddingTop: 5}}></Grid>
                      </Grid>

                      <Grid item lg={12} sm={12} xs={12} container justify="center"></Grid>
                    </Form.Item>
                  </Grid>




                  {/* DOAÇÃO PAYPAL */}

                    <InvisibleContent visible={fraseDoacao5 === false && fraseDoacao6 === false && fraseDoacao7 === false && fraseDoacao8 === false && fraseDoacao9 === false}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 55}}>
                        <Form
                          form={formPessoaRef}
                          scrollToFirstError={true}
                          onFinish={onSubmitPessoa}
                        >
                          <ButtonComponent
                            color="secondary"
                            loading={loadingPessoa}
                            type='submit'
                            style={{height: 65, width: 200, fontSize: 16, paddingLeft: 10}}
                            //onClick ={() => HandleChangeEtapa(3)}
                          >
                            Continuar
                            <img src={ProximoAzul} style={{ height: 40, width: 40, marginLeft: 10}} />
                          </ButtonComponent>
                        </Form>
                      </Grid>
                    </InvisibleContent>

                    <InvisibleContent visible={fraseDoacao5 === true}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 70}}>

                             <PayPalButton
                          paypalOptions={{clientId: "AUXC9WOIHE4ORLR6smQIbH9Txam9pVsF1ytZC9Ry778OejykvOfmrStuGVin9n3Ae2zGTTWiSbXujOYZ", intent: 'capture', currency: "BRL", }}
                          buttonStyles={{
                            layout: "horizontal",
                            color: "gold",
                            label: "paypal",
                            tagline: false,
                            height: 40,
                            width: 350,
                            borderRadius: 50,
                          } as any}
                          amount={valorPaypal1}
                          onPaymentSuccess={onApprove}
                        />



                      </Grid>
                    </InvisibleContent>

                    <InvisibleContent visible={fraseDoacao6 === true}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 70}}>
                      <ButtonComponent
                            color="quartenary"
                            loading={loadingPessoa}
                            type='submit'
                            style={{height: 40, width: 160, fontSize: 16, paddingLeft: 10}}
                            //onClick ={() => HandleChangeEtapa(3)}
                          >
                             <PayPalButton
                          paypalOptions={{clientId: "AUXC9WOIHE4ORLR6smQIbH9Txam9pVsF1ytZC9Ry778OejykvOfmrStuGVin9n3Ae2zGTTWiSbXujOYZ", intent: 'capture', currency: "BRL", }}
                          buttonStyles={{
                            layout: "horizontal",
                            color: "gold",
                            label: "paypal",
                            tagline: false,
                            height: 40,
                            width: 350,
                            borderRadius: 50,
                          } as any}
                          amount={valorPaypal2}
                          onPaymentSuccess={onApprove}
                        />
                          </ButtonComponent>

                      </Grid>
                    </InvisibleContent>

                    <InvisibleContent visible={fraseDoacao7 === true}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 70}}>
                      <ButtonComponent
                            color="quartenary"
                            loading={loadingPessoa}
                            type='submit'
                            style={{height: 40, width: 160, fontSize: 16, paddingLeft: 10}}
                            //onClick ={() => HandleChangeEtapa(3)}
                          >
                             <PayPalButton
                          paypalOptions={{clientId: "AUXC9WOIHE4ORLR6smQIbH9Txam9pVsF1ytZC9Ry778OejykvOfmrStuGVin9n3Ae2zGTTWiSbXujOYZ", intent: 'capture', currency: "BRL", }}
                          buttonStyles={{
                            layout: "horizontal",
                            color: "gold",
                            label: "paypal",
                            tagline: false,
                            height: 40,
                            width: 350,
                            borderRadius: 50,
                          } as any}
                          amount={valorPaypal3}
                          onPaymentSuccess={onApprove}
                        />
                          </ButtonComponent>

                      </Grid>
                    </InvisibleContent>

                    <InvisibleContent visible={fraseDoacao8 === true}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 70}}>
                      <ButtonComponent
                            color="quartenary"
                            loading={loadingPessoa}
                            type='submit'
                            style={{height: 40, width: 160, fontSize: 16, paddingLeft: 10}}
                            //onClick ={() => HandleChangeEtapa(3)}
                          >
                             <PayPalButton
                          paypalOptions={{clientId: "AUXC9WOIHE4ORLR6smQIbH9Txam9pVsF1ytZC9Ry778OejykvOfmrStuGVin9n3Ae2zGTTWiSbXujOYZ", intent: 'capture', currency: "BRL", }}
                          buttonStyles={{
                            layout: "horizontal",
                            color: "gold",
                            label: "paypal",
                            tagline: false,
                            height: 40,
                            width: 350,
                            borderRadius: 50,
                          } as any}
                          amount={valorPaypal4}
                          onPaymentSuccess={onApprove}
                        />
                          </ButtonComponent>
                      </Grid>
                    </InvisibleContent>

                    <InvisibleContent visible={fraseDoacao9 === true}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 70}}>
                      <ButtonComponent
                            color="quartenary"
                            loading={loadingPessoa}
                            type='submit'
                            style={{height: 40, width: 160, fontSize: 16, paddingLeft: 10}}
                            //onClick ={() => HandleChangeEtapa(3)}
                          >
                             <PayPalButton
                          paypalOptions={{clientId: "AUXC9WOIHE4ORLR6smQIbH9Txam9pVsF1ytZC9Ry778OejykvOfmrStuGVin9n3Ae2zGTTWiSbXujOYZ", intent: 'capture', currency: "BRL", }}
                          buttonStyles={{
                            layout: "horizontal",
                            color: "gold",
                            label: "paypal",
                            tagline: false,
                            height: 40,
                            width: 350,
                            borderRadius: 50,
                          } as any}
                          amount={valorPaypal5}
                          onPaymentSuccess={onApprove}
                        />
                          </ButtonComponent>

                      </Grid>
                    </InvisibleContent>



                  <Grid container item lg={12} sm={12} xs={12} style={{marginTop: 15, marginBottom: 50}}>
                    <Grid  container item lg={3} sm={3} xs={12} justify="center" style={{marginLeft: 50}}></Grid>
                    <Grid  container item lg={5} sm={5} xs={12} justify="center"  style={{marginLeft: 5, marginRight: 5}}>





                    </Grid>
                    <Grid  container item lg={3} sm={3} xs={12} justify="center"></Grid>
                  </Grid>

                </Grid>

            </Grid>

            {/* ------------- ETAPA 4 (FORMA DE PAGAMENTO - DOAÇÃO RECORRENTE) -----------------------------------------------------------------*/}


            {/* ---------------- ETAPA 5 (ENDEREÇO - DOAÇÃO RECORRENTE) ------------------------------------------------------------*/}





            {/* ------- ETAPA 6 (OUTROS DADOS FORMA DE PAGAMENTO - DOAÇÃO RECORRENTE) --------------------*/}



            {/* ------------- ETAPA 7 (FORMA DE PAGAMENTO - DOAÇÃO ÚNICA) -----------------------------------------------------------------*/}



            {/* ---------------- ETAPA 8 (ENDEREÇO - DOAÇÃO ÚNICA) ------------------------------------------------------------*/}





            {/* ----------------------------- ETAPA 9 ( ACEITES LGPD - DOAÇÃO RECORRENTE) --------------------*/}


            {/* ----------------------------- ETAPA 10 ( ACEITES LGPD - DOAÇÃO ÚNICA) --------------------*/}


          </Form>
          </InvisibleContent>

          <InvisibleContent visible={openModalTermo === true}>
            <InvisibleContent visible={doacaoRecorrente === true}>
              <AgradecimentoRecorrente />
            </InvisibleContent>

          <InvisibleContent visible={doacaoRecorrente === false}>
            <AgradecimentoUnica />
          </InvisibleContent>

          <InvisibleContent visible={doacaoPaypal === true}>
            <AgradecimentoUnica />
          </InvisibleContent>

          </InvisibleContent>
        </Grid> {/* background */}


          {/* ------------------ RODAPÉ 1 ----------------------- */}

            <FooterInfos/>

          {/* ------------------ RODAPÉ 2 ----------------------- */}

            <FooterSociallis/>

      </Grid>



    </>
  );
};

export default Principal;
